import { render, staticRenderFns } from "./CACG0070.vue?vue&type=template&id=21cadba1"
import script from "./CACG0070Controller.ts?vue&type=script&lang=ts&external"
export * from "./CACG0070Controller.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports